var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-radio-group",
    _vm._b(
      {
        directives: [
          { name: "removeAriaHidden", rawName: "v-removeAriaHidden" },
        ],
        staticStyle: { width: "100%" },
        model: {
          value: _vm.changeValue,
          callback: function ($$v) {
            _vm.changeValue = $$v
          },
          expression: "changeValue",
        },
      },
      "el-radio-group",
      Object.assign({}, _vm.item),
      false
    ),
    [
      _vm._l(_vm.getOptions(), function (option, index) {
        return [
          !_vm.isHideQuota(option)
            ? _c(
                "div",
                {
                  key: option.value,
                  staticClass: "show-vote",
                  class: [
                    _vm.item.config.inline ? "inline-block" : "block",
                    _vm.isChecked(option.value) ? "checked" : "",
                    _vm.item.disabled ? "disabled" : "",
                    _vm.curSelectedOption === option.value ? "highWeight" : "",
                  ],
                },
                [
                  _vm.mode === "design"
                    ? _c(
                        "div",
                        { staticClass: "drawing-list picture" },
                        [
                          _c(
                            "upload-img",
                            {
                              key: "picture" + option.value,
                              attrs: {
                                "show-file-list": false,
                                listType: "text",
                                limitCount: 100,
                              },
                              on: {
                                uploadSuccess: function (res) {
                                  return _vm.uploadLogoHandle(res, index)
                                },
                              },
                            },
                            [
                              _c("template", { slot: "btn" }, [
                                _c(
                                  "span",
                                  { staticClass: "drawing-item__picture" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-picture-outline",
                                    }),
                                  ]
                                ),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        offset: "62",
                        disabled:
                          _vm.changeValue === option.value ||
                          _vm.mode !== "design",
                        effect: "dark",
                        content: "设为默认选中",
                        placement: "top-start",
                      },
                    },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: {
                            disabled:
                              option.quotaSetting &&
                              _vm.getSurplusQuota(option) <= 0,
                            label: option.value,
                          },
                          nativeOn: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.handleClick(option)
                            },
                          },
                        },
                        [
                          _vm.getSurplusQuota(option) <= 0 &&
                          _vm.item.config.quotaBlankWarning
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.item.config.quotaBlankWarning)
                                ),
                              ])
                            : _c("span", [_vm._v(_vm._s(option.label))]),
                          _vm.showQuota(option)
                            ? _c("span", { staticClass: "text-muted" }, [
                                _vm._v(
                                  "(余" +
                                    _vm._s(_vm.getSurplusQuota(option)) +
                                    ")"
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm.mode === "design" || option.description
                    ? _c(
                        "div",
                        { staticClass: "option_desc_input" },
                        [
                          _vm.mode === "design"
                            ? _c("el-input", {
                                attrs: { placeholder: "选项描述" },
                                model: {
                                  value: option.description,
                                  callback: function ($$v) {
                                    _vm.$set(option, "description", $$v)
                                  },
                                  expression: "option.description",
                                },
                              })
                            : option.description
                            ? _c("span", { staticClass: "option_desc" }, [
                                _vm._v(_vm._s(option.description)),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "vote-wrap" },
                    [
                      (option.value === 0 || option.isFill) &&
                      _vm.isChecked(option.value)
                        ? [
                            _c(
                              "div",
                              { staticClass: "extension_box" },
                              [
                                option.required
                                  ? _c("span", { staticClass: "required_icon" })
                                  : _vm._e(),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "extension_item",
                                    attrs: {
                                      prop:
                                        _vm.item.vModel +
                                        "extension_" +
                                        option.value,
                                      label: "",
                                      rules: {
                                        required:
                                          option.required &&
                                          _vm.item.isFieldShow,
                                        message: "选项后内容为必填项",
                                        trigger: ["blur", "change"],
                                      },
                                    },
                                  },
                                  [
                                    option.fillContent
                                      ? _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              "popper-append-to-body": false,
                                            },
                                            on: {
                                              change: function (val) {
                                                return _vm.optionExtensionChange(
                                                  val,
                                                  option.value
                                                )
                                              },
                                              focus: function ($event) {
                                                return _vm.selectFocus(
                                                  option.value
                                                )
                                              },
                                            },
                                            model: {
                                              value: option.inputValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  option,
                                                  "inputValue",
                                                  $$v
                                                )
                                              },
                                              expression: "option.inputValue",
                                            },
                                          },
                                          _vm._l(
                                            option.fillContentJson,
                                            function (opt) {
                                              return _c("el-option", {
                                                key: opt.value,
                                                attrs: {
                                                  value: opt.label,
                                                  label: opt.label,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      : _c("el-input", {
                                          staticClass: "other-input",
                                          on: {
                                            input: function (val) {
                                              return _vm.optionExtensionChange(
                                                val,
                                                option.value
                                              )
                                            },
                                          },
                                          model: {
                                            value: option.inputValue,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                option,
                                                "inputValue",
                                                $$v
                                              )
                                            },
                                            expression: "option.inputValue",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      option.optionImgUrl
                        ? [
                            _vm.mode === "design"
                              ? _c("upload-img", {
                                  attrs: {
                                    alreadyFile: option.optionImgUrl,
                                    listType: "picture-card",
                                  },
                                  on: {
                                    removeSuccess: function ($event) {
                                      return _vm.removeBgImgHandle(index)
                                    },
                                  },
                                })
                              : _c(
                                  "el-image",
                                  {
                                    staticClass: "image",
                                    attrs: {
                                      "preview-src-list": [option.optionImgUrl],
                                      src: option.optionImgUrl,
                                      fit: "contain",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "image-slot",
                                        attrs: { slot: "error" },
                                        slot: "error",
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-picture-outline",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                          ]
                        : _vm._e(),
                      _vm.item.config.showVoteResult
                        ? _c("vote", {
                            attrs: {
                              value: option.value,
                              "vote-list": _vm.voteList,
                              "total-vote": _vm.totalVote,
                            },
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }